// HELPERS
import {inArray} from "@helpers/utils";
import {mergeViewStateForFulfillment} from "../../../Cob.helpers";
import Validator from "../../../../../classes/Validator.js";


export default function (state, prevState)
{
	if (import.meta.env.VITE_CHECK_VIEW_FULFILLMENT === "0")
	{
		return true;
	}
	state = mergeViewStateForFulfillment(state, prevState);
	const {customerState} = state;
	const {isCompany, companyReps, companyRepsActiveAmount} = customerState;

	// WARNING Fields specific for private individuals need to be placed lower in the document
	// US Person inte tillåten just nu
	if (customerState.isUsPerson !== "no")
	{
		return false;
	}

	// Hur länge har vi handlat med finansiella instrument måste vara vald
	if (customerState.yearsExperience.length <= 0) {
		return false;
	}

	// Högsta utbildningsnivå måste vara ifylld
	if (customerState.highestEducationIndex === -1) {
		return false;
	}

	// Om man valt universitet måste inriktning anges
	if (customerState.highestEducationIndex === 2 && customerState.customer_university.length <= 0) {
		return false;
	}

	// Nuvarande eller tidigare befattning måste vara vald
	if (customerState.currentOrPreviousCareerIndex === -1) {
		return false;
	}

	// Vad är kundens syfte med investeringen? måste kryssas
	if (!inArray("yes", [
		customerState.checkbox_aml_purpose_longtime_savings,
		customerState.checkbox_aml_purpose_single,
		customerState.checkbox_aml_purpose_other
	]))
	{
		return false;
	}

	// Size of the initial deposit needs to be answered
	if (customerState.aml_first_deposit.length <= 0 || customerState.aml_first_deposit < 0)
	{
		return false;
	}

	// Type of deposit needs to be answered
	if (customerState.radio_deposit_type.length <= 0)
	{
		return false;
	}


	// Q about previous experience needs to be answered
	if (customerState.radio_customer_experience.length <= 0)
	{
		return false;
	}

	if (isCompany)
	{
		// UBO option needs to be selected
		if (customerState.hasUbo !== "yes" && customerState.hasUbo !== "no")
		{
			return false;
		}

		/**
		 * Ingen huvudman, då måste alternativ huvudman vara ifyllt
		 */
		if (customerState.hasUbo === "no")
		{
			if (customerState.company_benowner_alt_name.length <= 0 ||
				customerState.company_benowner_alt_ssn.length <= 0 ||
				customerState.company_benowner_alt_title.length <= 0 ||
				!Validator.validateSsn(customerState.company_benowner_alt_ssn))
			{
				return false;
			}
		}

		if (customerState.hasUbo === "yes" && customerState.companyRepsActiveAmount <= 0)
		{
			return false;
		}

		/**
		 * PEP-frågorna för huvudman måste också kryssas nej alltid
		 */
		if (customerState.isBenPep.length <= 0 || customerState.isBenPepPast.length <= 0)
		{
			return false;
		}

		if (customerState.isBenPep === "yes" && customerState.ben_pep_info.length <= 0)
		{
			return false;
		}

		if (customerState.isBenPepPast === "yes" && customerState.ben_pep_info_relative.length <= 0)
		{
			return false;
		}

		if (customerState.hasUbo === "yes")
		{
			return _validateCompanyRep(companyReps[0], companyRepsActiveAmount < 1) &&
				_validateCompanyRep(companyReps[1], companyRepsActiveAmount < 2) &&
				_validateCompanyRep(companyReps[2], companyRepsActiveAmount < 3) &&
				_validateCompanyRep(companyReps[3], companyRepsActiveAmount < 4) &&
				_validateCompanyRep(companyReps[4], companyRepsActiveAmount < 5) &&
				_validateCompanyRep(companyReps[5], companyRepsActiveAmount < 6);
		}


		if (customerState.radio_company_form == null ||
			customerState.radio_company_form.length <= 0 ||
			customerState.radio_company_active.length <= 0 ||
			customerState.radio_company_revisor.length <= 0 ||
			customerState.company_business.length <= 0 ||
			customerState.radio_company_fininst.length <= 0 ||
			customerState.radio_company_turnover.length <= 0 ||
			customerState.radio_company_employees.length <= 0)
		{
			return false;
		}

		// Var kommer pengarna ifrån, något måste väljas
		if (!inArray("Ja", [
			customerState.checkbox_company_funds_profit,
			customerState.checkbox_company_funds_aktiekapital,
			customerState.checkbox_company_funds_compsales,
			customerState.checkbox_company_funds_invest,
			customerState.checkbox_company_funds_membership,
			customerState.checkbox_company_funds_donation,
			customerState.checkbox_company_funds_grants
		]))
		{
			return false;
		}

		// Från vilken bank institut...
		if (!inArray("yes", [
			customerState.swedishBank,
			customerState.foreignBank,
			customerState.swedishInsurance,
			customerState.foreignInsurance,
			customerState.sourcePension,
			customerState.sourceEmployer,
			customerState.checkbox_customer_kyc_deposit_other
		]))
		{
			return false;
		}

		// Om man valt "Annat" måste textfältet fyllas i
		if (customerState.checkbox_customer_kyc_deposit_other === "yes" && customerState.customer_kyc_deposit_other.length <= 0)
		{
			return false;
		}

		return true;
	}

	if (customerState.isPep.length <= 0 || customerState.isPepPast.length <= 0)
	{
		return false;
	}

	// Huvudsaklig sysselsättning needs to be selected
	if (customerState.radio_kyc_form_employment.length <= 0) {
		return false;
	}

	if (customerState.radio_kyc_form_employment !== "Pensionär" &&
		customerState.radio_kyc_form_employment !== "Studerande" &&
		customerState.radio_kyc_employment_text.length <= 0) {
		return false;
	}

	// Sysselsättning nu och sist
	if (customerState.customer_occupation_last24m.length <= 0)
	{
		return false;
	}

	// Kunden måste äga pengar / värdepapper
	if (customerState.checkbox_aml_own_money !== 'yes')
	{
		return false;
	}

	// Var kommer pengarna ifrån, något måste väljas
	if (!inArray("yes", [
		customerState.checkbox_aml_origin_salary_pension,
		customerState.checkbox_aml_origin_capital,
		customerState.checkbox_advice_origin_business,
		customerState.checkbox_advice_origin_companyexit,
		customerState.checkbox_aml_origin_savings_herit_gift,
		customerState.checkbox_aml_origin_other,
	]))
	{
		return false;
	}

	if (customerState.checkbox_aml_origin_other === "yes" && customerState.aml_origin_other.length <= 0)
	{
		return false;
	}

	// Storlek på kundens insättningar
	if (!customerState.radio_aml_deposit_amt || customerState.radio_aml_deposit_amt.length <= 0)
	{
		return false;
	}

	// Hur ofta kund kommer göra insättningar
	if (!customerState.radio_aml_deposit || customerState.radio_aml_deposit.length <= 0)
	{
		return false;
	}

	// Från vilken bank/försäkringsbolag tar du kapital för dina investeringar?
	if (!inArray("yes", [
		customerState.swedishBank,
		customerState.swedishInsurance,
		customerState.foreignBank,
		customerState.foreignInsurance,
		customerState.sourcePension,
		customerState.sourceEmployer,
		customerState.checkbox_customer_kyc_deposit_other
	]))
	{
		return false;
	}

	// Om man valt "Annat" måste textfältet fyllas i
	if (customerState.checkbox_customer_kyc_deposit_other === "yes" && customerState.customer_kyc_deposit_other.length <= 0)
	{
		return false;
	}

	// If given other purpose the text needs to be filled out
	if (customerState.checkbox_aml_purpose_other === "yes" && customerState.aml_purpose_other.length <= 0)
	{
		return false;
	}

	// Type of deposit needs to be answered
	if (customerState.radio_deposit_type.length <= 0)
	{
		return false;
	}

	return true;
}


function _validateCompanyRep(rep, fallbackValue = false)
{
	if (fallbackValue)
	{
		return true;
	}

	if (!rep.isCompany)
	{
		if (!Validator.validateSsn(rep.ssn))
		{
			return false;
		}

		return !!((
			rep.firstName.length > 0
			&& rep.lastName.length > 0
			&& rep.ssn.length > 0
		));
	}

	if (rep.firstName.length <= 0 || rep.ssn.length <= 0)
	{
		return false;
	}

	let ssnForValidation = rep.ssn;
	if (ssnForValidation.substring(0, 2) === "16")
	{
		ssnForValidation = ssnForValidation.substring(2);
	}

	if (!Validator.validateOrgNum(ssnForValidation))
	{
		return false;
	}

	return true;
}